import { render, staticRenderFns } from "./CustomerOrgGridPanel.vue?vue&type=template&id=a5b28ad6&"
import script from "./CustomerOrgGridPanel.vue?vue&type=script&lang=js&"
export * from "./CustomerOrgGridPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrgGridPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports